/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskResponseDto } from '../../models/core-project-task-response-dto';

export interface ProjectTasksControllerFindOne$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the project task to retrieve.
 */
  id: string;
}

export function projectTasksControllerFindOne(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectTaskResponseDto>;
    })
  );
}

projectTasksControllerFindOne.PATH = '/o2-core/project-tasks/{tenant}/{id}';
